import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentJointSelectAccountData,
  type EnrollmentJointSelectAccountSubmitInput,
  type EnrollmentJointSelectAccountSubmitOutput,
} from '../../../../models'

export const getEnrollmentJointSelectAccountDataMock: EnrollmentJointSelectAccountData = {
  errors: [],
  isError: false,
  activePerson: {
    applicationId: '1234567890',
    path: '/enrollment/joint/select-account',
    progress: 10,
  },
}

export const submitEnrollmentJointSelectAccountInputMock: EnrollmentJointSelectAccountSubmitInput = {
  initiateApplication: true,
}

export const submitEnrollmentJointSelectAccountDataMock: EnrollmentJointSelectAccountSubmitOutput = {
  errors: [],
  isError: false,
  activePerson: {
    path: '/enrollment/joint/account-type',
    progress: 20,
  },
}

export const mockGetEnrollmentJointSelectAccountData = graphql.mutation('getEnrollmentJointSelectAccountData', () => {
  return HttpResponse.json({ data: { submitJointEnrollment: getEnrollmentJointSelectAccountDataMock } })
})

export const mockSubmitEnrollmentJointSelectAccountData = graphql.mutation(
  'submitEnrollmentJointSelectAccountData',
  () => {
    return HttpResponse.json({ data: { submitJointEnrollment: submitEnrollmentJointSelectAccountDataMock } })
  },
)

export const mockEnrollmentJointSelectAccount = [
  mockGetEnrollmentJointSelectAccountData,
  mockSubmitEnrollmentJointSelectAccountData,
]
